.mf-service-reports ux-accordion[is-expanded] [slot="title"] {
  color: var(--ux-color-primary);
}

.mf-service-reports .ux-filter fieldset {
  border: 0;
  padding: 0;
  margin: 0 0 15px;
  display: inline-block;
}

.mf-service-reports ux-date-range-picker {
  margin-right: 20px;
}

.mf-service-reports .ux-dropdown {
  min-width: 248px;
}

.mf-service-reports .ux-info-box {
  margin-bottom: 20px;
}

.mf-service-reports__report-item .ux-text-title {
  margin-bottom: 0;
}

.mf-service-reports .mf-service-reports__report-spacer {
  flex-grow: 1;
  width: auto;
}

.mf-service-reports__error {
  color: #ff0201;
}
